import React from 'react';

export type SidebarProps = {
  children: React.ReactNode;
};

export function Sidebar({ children }: SidebarProps) {
  return (
    <div className='w-full md:min-w-[366px] md:w-[366px] border-0 border-r border-solid border-neutral-200'>
      {children}
    </div>
  );
}

export default Sidebar;
